/**
 * Functionality for read more / less toggle on people listing.
 *
 * @package  Actinium
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';
import { breakpoints } from './variables';
/**
 * Screensize that mobile menu is enabled/disabled
 *
 * @type {Int}
 */
const menuBreakPoint = breakpoints.md.min;

/**
 * Toggle mobile submenus on click.
 *
 * @param  {Event} e
 */
const headerSearch = {
	init() {
		this.form = document.getElementsByClassName('search-form');
		this.headerForm = document.querySelector('.site-header .search-form-wrapper');
		this.headerField = document.querySelector('.site-header .search-submit');

		let i;
		for (i = 0; i < this.form.length; i++) {
			if (this.form[i]) {
				this.closeForm = this.closeForm.bind(this);
				document.addEventListener('click', this.closeForm);
				document.addEventListener('touchend', this.closeForm);

				this.openForm = this.openForm.bind(this);
				this.headerField.addEventListener('click', this.openForm);
				this.headerField.addEventListener('touchend', this.openForm);
			}
		}
	},
	closeForm(e) {
		if (e.target.classList.contains('search-submit') || e.target.classList.contains('search-field')) {
			return;
		}

		this.headerForm.classList.remove('active');
		this.headerField.value = '';
	},
	stopProp(e) {
		e.stopPropagation();
	},
	openForm(e) {
		if (!(this.headerForm.classList.contains('active') || (window.innerWidth < menuBreakPoint))) {
			e.preventDefault();
			e.stopPropagation();
			$('.site-header .search-form-wrapper .search-field').focus();
			this.headerForm.classList.add('active');
		}
	},
};

headerSearch.init();
